import { MeetingType } from "./meetingTypeToTranslationKey";

export const getMeetingBorderColor = (type: MeetingType) => {
  switch (type) {
    case "VISIT":
      return "#f54758";
    case "TAKING_MEASUREMENTS":
      return "#ad7611"; // brown
    case "FIRST_MEASUREMENT":
      return "#12ad27"; // green
    case "SECOND_MEASUREMENT":
      return "#4899ad"; // blue
    case "OTHER":
      return "#bebebf"; // gray
    case "CONTRACT":
      return "#ffff5b"; // yellow
    case "RECEIVING":
      return "#ad579f"; // pink
    case "WAITING_LIST":
      return "#CFE2F3"; // blue
    case "NOTE":
      return "#bebebf"; // gray
    case "SECOND_MEASUREMENT_AND_RECEIVING":
      return "#fdeb92"; // yellow
    case "SECOND_VISIT":
      return "#e67e22"; // orange
    case "THIRD_VISIT":
      return "#c0392b"; // dark orange/red
    case "CONSULTING_SERVICES":
      return "#8e44ad"; // purple
    default:
      return "black";
  }
};

export const getMeetingColor = (type: MeetingType) => {
    switch (type) {
      case "VISIT":
        return "#FADADD"; // red
      case "TAKING_MEASUREMENTS":
        return "#ad7611"; // orange
      case "FIRST_MEASUREMENT":
        return "#b4fab5"; // green
      case "SECOND_MEASUREMENT":
        return "#b1c8fa"; // blue
      case "OTHER":
        return "#bebebf"; // gray
      case "CONTRACT":
        return "#ffff5b"; // yellow
      case "RECEIVING":
        return "#fabcf6"; // pink
      case "WAITING_LIST":
        return "#CFE2F3"; // blue
      case "NOTE":
        return "grey"; // gray
      case "SECOND_MEASUREMENT_AND_RECEIVING":
        return "#ffff5b"; // yellow
      case "SECOND_VISIT":
        return "#fad7a0"; // light orange
      case "THIRD_VISIT":
        return "#f5b7b1"; // light red
      case "CONSULTING_SERVICES":
        return "#d7bde2"; // light purple
      default:
        return "black";
    }
};
